/** Dhivehi labels for the agenda return form (official PR-05 V2 template, "ޖަދުވަލު 4"). */
export const AGENDA_RETURN_FORM_FIELD_LABELS = {
    formReference: "ޖަދުވަލު 4 - PR-05",
    title: "ބިޑު ކޮމިޓީއަށް ހުށަހަޅާފައިވާ ހުށަހެޅުން އަނބުރާ ފޮނުވާލާ ފޯމް",
    meetingDate: "ބިޑްކޮމިޓީގެ ޖަލްސާކުރި ތާރީޚް:",
    meetingNumber: "ޖަލްސާ ނަންބަރު:",
    procurementName: "ޕްރޮކިއުމަންޓް/މަޝްރޫޢު/މައްސަލައިގެ ނަން:",
    procurementNumber: "ޕްރޮކިއުމަންޓް/މަޝްރޫޢުގެ ނަންބަރު:",
    budget: "ހަމަޖެހިފައިވާ ޖުމުލަ ބަޖެޓް:",
    reasonsForReturning: "އަނބުރާ ފޮނުވާލާ ސަބަބު:",
    detailsOfAmendments: "ކަމެއް އިޞްލާޙުކުރަން ޖެހޭނަމަ އެކަމެއްގެ ތަފްސީލު:",
    resubmission: "އިޞްލާޙުކުރުމަށްފަހު އަލުން ހުށަހެޅުމަށް ފުރުސަތުދޭނަމަ އެކަމެއްގެ ތަފްސީލު:",
    acknowledgement: "އިޤްރާރު:",
    acknowledgementText: "މަތީގައިވާ މަޝްރޫޢުއާއި ގުޅިގެން ހުށަހަޅާފައިވާ އެންމެހާ ލިޔެކިޔުންތައް ބިޑު ކޮމިޓީގައި މަޝްވަރާކޮށް ބަލައި ޗެކްކުރުމަށްފަހު، ދައުލަތުގެ މާލިއްޔަތުގެ ގަވާއިދާއި އެގަވާއިދުގެ ދަށުން ހަދާފައިވާ އުޞޫލުތަކާއި އެއްގޮތްވާ ގޮތުގެ މަތިން މަތީގައިވާ ގޮތަށް އަމަލު ކުރުމަށް އަންގަމެވެ.",
    colMemberName: "މެމްބަރުންގެ ނަން",
    colOffice: "އޮފީސް/ އެހެނިހެން",
    colPass: "ފާސް (ސޮއި)",
    colFail: "ފެއިލް (ސޮއި)",
    pass: "ފާސް",
    fail: "ފެއިލް",
    chairPerson: "ބައްދަލުވުމުގެ ޗެއަރޕަރސަން:",
    secretary: "ބައްދަލުވުމުގެ ސެކްރެޓަރީ:",
    nameLabel: "ނަން:",
    signatureLabel: "ސޮއި:",
};
/**
 * The name, number and budget rows of the return form. The name is the agenda item's subject (the
 * matter put to the committee), falling back to the linked procurement's name. Tenders carry no budget.
 */
export function agendaReturnFormProcurement(form) {
    const item = form.agendaItem;
    const tender = item?.tender ?? form.tender;
    const ss = item?.singleSource ?? form.singleSource;
    const pss = item?.projectSummarySheet ?? form.projectSummarySheet;
    let name;
    let number;
    let budget;
    if (tender) {
        name = tender.description;
        number = tender.referenceNo;
    }
    else if (ss) {
        name = ss.projectName || ss.title;
        number = ss.formNumber;
        budget = item?.singleSource?.proposedCost;
    }
    else if (pss) {
        name = pss.projectName;
        number = pss.summarySheetNumber;
        budget = item?.projectSummarySheet?.estimatedCost;
    }
    const budgetNumber = budget == null || budget === "" ? NaN : Number(budget);
    return {
        name: item?.subject?.trim() || name || null,
        number: number || null,
        budget: Number.isNaN(budgetNumber) ? null : budgetNumber,
    };
}
/** "100,249.99ރ" — a Rufiyaa amount as written on the return form. */
export function formatReturnFormBudget(budget) {
    if (budget == null)
        return null;
    const figure = budget.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${figure}ރ`;
}
//# sourceMappingURL=agendaReturnFormFieldLabels.js.map